import { Component, OnInit } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
declare var $;
@Component({
  selector: 'signSuccess-component',
  templateUrl: './signSuccess.component.html'
})
export class SignSuccessComponent extends BaseComponent implements OnInit  {

  constructor(  
    public _sanitizer: DomSanitizer
  ) {
    super();
  }
  public Data;
  ngOnInit() {
    var msg = this.jslib.GetStorage('signup');
    this.jslib.SetStorage('signup',null);
    if(msg){
      this.Data = msg;
      //console.log(this.Data);
    }else{
      this.route.navigateByUrl('/home');
    }
  }
}
